import { useState, useEffect, useRef } from "react";
import { Tooltip } from "react-tooltip";
import { useNavigate, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faArrowCircleRight,
  faCalendar,
  faAngleDown,
} from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import logoImg from "./img/Tiara-logo-type1.jpg";
import MenuDescription from "./MenuDescription";
import { menus } from "./data/header";


const Header = () => {
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(false);

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setShowHeader(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuClick = () => {
    if (window.innerWidth <= 992) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleNavigate = () => {
    navigate("/appointment");
  };

  const handleHome = () => {
    navigate("/");
  }

  const handleMenuToggle = (menu) => {
    if (window.innerWidth <= 992) {
      setActiveTooltip((prev) => (prev === menu.key ? null : menu.key));

      if (menu.subMenu?.length) {
        setActiveSubMenu({
          description: menu.subMenu[0].description,
          icon: menu.subMenu[0].icon,
        });
      }
    }
  };

  // Added by Sam 
  // Function to close the submenu and reset active states
  const closeSubMenu = () => {
    setActiveTooltip(null);
    setActiveSubMenu(null);
    handleMenuClick();
  };

  return (
    <>  
      <div className="header" id="header-navigator">
        <div
          className={`header-bg ${showHeader ? "header-visible" : "header-invisible"}`}
        ></div>

        <div className={`header-wrapper header-wrp-opaque`}>
          <div className="logo-hamburger">
            <div
              className={`nav-toggle-label ${isMobileMenuOpen ? "open" : ""}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className="company-logo">
              <img
                src={logoImg}
                alt="Company Logo"
                className="company-logo-img"
                onClick={handleHome}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>

          <div className="header-control-mobile">
            <a
              href="tel:+1 (202) 394-2630"
              style={{ color: "inherit", marginRight: "10px" }}
            >
              <div className="header-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
            </a>
            <a
              data-tooltip-id="appointment-tooltip"
              style={{ color: "#fff", marginRight: "10px" }}
              data-tooltip-content="Schedule an appointment"
            >
              <div className="header-icon" onClick={handleNavigate}>
                <FontAwesomeIcon icon={faCalendar} />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/in/tiarasoftware"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="header-icon">
                <FontAwesomeIcon icon={faLinkedin} />
              </div>
            </a>
          </div>

          <div
            className={`header-category ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}
          >
            <NavLink
              to="/"
              className="header-menu"
              onClick={(e) => {
                e.preventDefault();
                handleMenuClick();
                navigate("/", { state: { resetBanner: true } });
              }}
            >
              Home
            </NavLink>
            {menus.map((menu) => (
              <div
                className="custom-tooltip"
                key={menu.key}
                // Lakshmipriya Menu Align responsive code
                onMouseEnter={() => {
                  if (!isMobile) {
                    setActiveTooltip(menu.key);
                    if (menu.subMenu?.length) {
                      setActiveSubMenu({
                        description: menu.subMenu[0].description,
                        icon: menu.subMenu[0].icon,
                      });
                    }
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    setActiveTooltip(null);
                    setActiveSubMenu(null);
                  }
                }}
              >
                <NavLink
                  to={menu.path}
                  className="header-menu"
                  onClick={(e) => {
                    if (window.innerWidth <= 992 && menu.subMenu?.length) {
                      if (activeTooltip === menu.key) {
                        handleMenuClick(); //  navigate
                      } else {
                        e.preventDefault(); //  open submenu
                        handleMenuToggle(menu);
                      }
                    } else {
                      handleMenuClick();
                    }
                  }}
                >
                  {menu.label}
                  {menu.subMenu?.length > 0 && (
                    <FontAwesomeIcon
                      icon={faAngleDown}
                      className={`menu-arrow ${activeTooltip === menu.key ? "rotate" : ""
                        }`}
                    />
                  )}
                </NavLink>

                <div
                  className={`custom-tooltip-content 
    ${activeTooltip === menu.key ? "visible" : ""} 
    ${isMobile ? "mobile" : "desktop"}
  `}
                >
                  <div className="menu-content">
                    <div className="sub-menu-container">
                      {menu.subMenu?.map((item, index) => (
                        <div
                          className="sub-menu"
                          key={index}
                          onMouseEnter={() =>
                            setActiveSubMenu({
                              description: item.description,
                              icon: item.icon,
                            })
                          }
                          style={{ "--hover-color": item.color }}
                        >
                          {item.external ? (
                            <a
                              href={item.path}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="header-sub-menu"
                              onClick={closeSubMenu}
                            >
                              <div className="icon">{item.icon}</div>
                              <span>{item.text}</span>
                            </a>
                          ) : (
                            <NavLink
                              to={item.path}
                              className="header-sub-menu"
                              onClick={closeSubMenu}
                            >
                              <div className="icon">{item.icon}</div>
                              <span>{item.text}</span>
                            </NavLink>
                          )}
                          <FontAwesomeIcon
                            icon={faArrowCircleRight}
                            className="sub-menu-icon"
                          />
                        </div>
                      ))}
                    </div>

                    <div className="extra-content">
                      {activeSubMenu ? (
                        <div className="description-wrapper">
                          {activeSubMenu?.description && (
                            <MenuDescription
                              title={activeSubMenu.description.title}
                              sections={activeSubMenu.description.sections}
                            />
                          )}
                        </div>
                      ) : (
                        <p>{menus[0].description}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <NavLink
              to="/resources"
              className="header-menu"
              onClick={handleMenuClick}
            >
              Resources
            </NavLink>
            <NavLink
              to="/contact"
              className="header-menu"
              onClick={handleMenuClick}
            >
              Contact
            </NavLink>
          </div>

          <div className="header-control">
            <a
              href="tel:+1 (202) 394-2630"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="header-icon">
                <FontAwesomeIcon icon={faPhone} data-tooltip-id="whatsapp-tooltip"
              data-tooltip-content="Chat with Tiara on WhatsApp" />
              </div>
            </a>
             <Tooltip
              id="whatsapp-tooltip"
              place="bottom"
              style={{ backgroundColor: "#4c90f2", borderRadius: "15px" }}
            />
            <a
              data-tooltip-id="appointment-tooltip"
              data-tooltip-content="Schedule an Appointment"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="header-icon" onClick={handleNavigate}>
                <FontAwesomeIcon icon={faCalendar} />
              </div>
            </a>
            <Tooltip
              id="appointment-tooltip"
              place="bottom"
              style={{ backgroundColor: "#4c90f2", borderRadius: "15px" }}
            />
            <a  data-tooltip-id="LinkedIn-tooltip"
              data-tooltip-content="Connect with Tiara on LinkedIn"
              href="https://www.linkedin.com/in/tiarasoftware"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="header-icon">
                <FontAwesomeIcon icon={faLinkedin} />
              </div>
            </a>
              <Tooltip
              id="LinkedIn-tooltip"
              place="bottom"
              style={{ backgroundColor: "#4c90f2", borderRadius: "15px" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
